export default __webpack_public_path__ + "static/media/ic_orkney_islands.3530463c.svg";